<!--  -->
<template>
  <div>
    <el-input
      v-model="label"
      type="textarea"
      :rows="3"
      placeholder="请输入标签名称，输入多个请用英文逗号隔开"
      @blur="namesblur"
    />
    <div style="text-align: right;">
      <el-button
        style="margin-top: 30px;"
        type="primary"
        @click="labelclick"
      >确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      label: '',
      anlabel: []
    }
  },
  created() {},
  mounted() {},
  methods: {
    namesblur() {
      this.label = this.label.replace(/\n/g, ',')
    },
    labelclick() {
      this.anlabel = []
      this.anlabel = this.label.split(',')
      console.log(this.anlabel)
      this.$emit('callbackanlabel', this.anlabel)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>